import type {
	MessageActionInvocationStatus,
	MessageActionResolutions,
} from '@atlassian/conversation-assistant-service-api/types/message-actions';

export const BASE_PREVIEW_CARD_WIDTH = 320;

// Action statuses
export const MESSAGE_ACTION_INVOCATION_STATUSES: Record<string, MessageActionInvocationStatus> = {
	planned: 'planned',
	finished: 'finished',
	cancelled: 'cancelled',
};

// Action resolutions
export const MESSAGE_ACTION_RESOLUTIONS: Record<string, MessageActionResolutions> = {
	actioned: 'actioned',
	cancel: 'cancel',
};
